import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import FormControl from '../FormControl/FormControl.js';
import { isText } from '../Util/validations.js';

const Region = (_param)=> {
    var { label , errorMessage , validations =[
        isText
    ]  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "label",
        "errorMessage",
        "validations"
    ]);
    return React.createElement(FormControl, swcHelpers.extends({}, FormControl.defaultProps, {
        id: "region",
        "data-t": "region",
        label: label,
        errorMessage: errorMessage,
        validations: validations
    }, rest));
};
var Region$1 = Region;

export { Region$1 as default };
//# sourceMappingURL=Region.js.map
